import { GradientPath } from './GradientPath';

type Props = {
  className?: string;
};

export const Location = ({ className }: Props) => {
  return (
    <GradientPath
      className={className}
      height={38}
      width={26}
      render={(id) => (
        <path
          fill={`url(#${id})`}
          d="M12.69,37.4a3.69,3.69,0,0,1-1.93-.54,3.39,3.39,0,0,1-1.36-1.52L.84,17.17A10.55,10.55,0,0,1,0,12.69a12.27,12.27,0,0,1,3.72-9,12.27,12.27,0,0,1,9-3.72,12.28,12.28,0,0,1,9,3.72,12.28,12.28,0,0,1,3.72,9,10.58,10.58,0,0,1-.84,4.49L16,35.35a3.5,3.5,0,0,1-1.37,1.5A3.7,3.7,0,0,1,12.69,37.4Zm0-36.07a10.85,10.85,0,0,0-8,3.33,10.85,10.85,0,0,0-3.33,8A9.29,9.29,0,0,0,2,16.61l8.57,18.17a2.06,2.06,0,0,0,.83.94,2.37,2.37,0,0,0,2.48,0,2.2,2.2,0,0,0,.86-.94l8.54-18.17A9.31,9.31,0,0,0,24,12.69a10.86,10.86,0,0,0-3.33-8A10.86,10.86,0,0,0,12.69,1.33Zm0,18a6.46,6.46,0,0,1-4.72-2,6.46,6.46,0,0,1-2-4.72A6.46,6.46,0,0,1,8,8a6.47,6.47,0,0,1,4.72-2,6.47,6.47,0,0,1,4.72,2,6.46,6.46,0,0,1,2,4.72,6.45,6.45,0,0,1-2,4.72A6.46,6.46,0,0,1,12.69,19.37Zm0-12A5.1,5.1,0,0,0,8.91,8.91a5.11,5.11,0,0,0-1.57,3.78,5.11,5.11,0,0,0,1.57,3.78A5.1,5.1,0,0,0,12.69,18a5.1,5.1,0,0,0,3.78-1.57A5.1,5.1,0,0,0,18,12.69a5.11,5.11,0,0,0-1.57-3.78A5.11,5.11,0,0,0,12.69,7.34Z"
        />
      )}
    />
  );
};
